<template>
  <div id="login_header_block">
    <div id="login_header_logo_group">
      <Logo />
    </div>
    <!--<div id="login_hearer_lang_select">
      <div id="login_hearer_lang_select_img">
        <img alt="rus" src="/lk/images/rus.png" />
      </div>
      <div id="login_hearer_lang_select_text">Русский</div>
      <div id="login_hearer_lang_select_btn">
        <svg
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5 6L9.33013 0.75H0.669873L5 6Z" fill="#333333" />
        </svg>
      </div>
  </div>-->
    <div id="header_lang_marge">
      <div class="hearer_lang_select" @click="isHovering = !isHovering">
        <div class="hearer_lang_select_img">
          <img
            :src="
              store.serverConf[store.currentServer].path +
              '/images/' +
              store.langImages[store.langSelect.value]
            "
          />
        </div>
        <div class="hearer_lang_select_text">
          {{ store.langTextes[store.langSelect.value] }}
        </div>
        <div class="hearer_lang_select_btn">
          <svg>
            <use xlink:href="#select_item" />
          </svg>
        </div>
        <div
          v-if="isHovering"
          aria-hidden="false"
          style="
            position: absolute;
            z-index: 3000;
            margin-top: 35px;
            margin-left: -10px;
            padding: 2px;
            background: #fff;
            border: 1px solid #e4e7ed;
            box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
          "
        >
          <ul
            style="
              list-style: none;
              padding: 0px;
              margin: 0;
              box-sizing: border-box;
            "
          >
            <li
              class="hearer_dropdown_lang_select_text row"
              @click="selectEnglish"
            >
              <img
                alt="eng"
                :src="
                  store.serverConf[store.currentServer].path +
                  '/images/ae_flag_uk.png'
                "
              />
              <div
                style="
                  display: inline-block;
                  margin-top: -4px;
                  margin-left: 20px;
                "
              >
                English
              </div>
            </li>
            <li
              class="hearer_dropdown_lang_select_text row"
              @click="selectRussian"
            >
              <img
                alt="rus"
                :src="
                  store.serverConf[store.currentServer].path +
                  '/images/ae_flag_ru.png'
                "
              />
              <div
                style="
                  display: inline-block;
                  margin-top: -4px;
                  margin-left: 20px;
                "
              >
                Русский
              </div>
            </li>
          </ul>
        </div>
      </div>
      <svg display="none">
        <symbol
          width="10"
          height="6"
          id="select_item"
          viewBox="0 0 10 6"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M5 6L9.33013 0.75H0.669873L5 6Z" />
        </symbol>
      </svg>
    </div>
  </div>
</template>
<script>
import Logo from "@/components/Logo";
import { ref } from "vue";
import { useMyStorage } from "@/store/global";
export default {
  components: {
    Logo,
  },
  setup() {
    const store = useMyStorage();

    const isHovering = ref(false);
    const selectEnglish = () => {
      store.langSelect.value = 1;
      localStorage.setItem("auth.langSelect", "1");
    };
    const selectRussian = () => {
      store.langSelect.value = 0;
      localStorage.setItem("auth.langSelect", "0");
    };
    return {
      isHovering,
      store,
      selectEnglish,
      selectRussian,
    };
  },
};
</script>
<style lang="scss">
@media (min-width: 750px) {
  #login_header_block {
    position: relative;
    margin-left: 56px;
    padding-top: 60px;
    #header_lang_marge {
      margin-left: 350px;
      .hearer_lang_select_img {
        position: absolute;
        top: 14px;
        left: 0;
      }
    }
  }
}
//mobile
@media (max-width: 750px) {
  #login_header_block {
    position: relative;
    margin-left: 6px;
    padding-top: 60px;
    #header_lang_marge {
      margin-left: 200px;
      .hearer_lang_select_img {
        display: none;
      }
    }
  }
}

#login_hearer_lang_select {
  position: relative;
  float: left;
  margin-left: 395px;
}

#login_hearer_lang_select_text {
  position: absolute;
  top: 12px;
  left: 42px;
  font-family: Proxima Nova Regular;
  font-style: normal;
  /* font-weight: normal;*/
  font-size: 17px;
  line-height: 21px;
  /* identical to box height */

  color: #333333;
}

#login_hearer_lang_select_img {
  position: absolute;
  top: 14px;
  left: 0;
}

#login_hearer_lang_select_btn {
  position: absolute;
  top: 11px;
  left: 114px;
}

/* HEADER */
.header {
  width: 100%;
  height: 68px;
}

.header_block {
  position: relative;
  width: 1395px;
  height: 44px;
  margin-left: 241px;
  margin-top: 24px;
}

/* Rectangle 1 */
.header_button {
  margin-left: 994px;
  float: left;
}

.hearer_lang_select {
  position: relative;
  float: left;
  margin-left: 39px;
  cursor: pointer;
}

.hearer_lang_select_text {
  position: absolute;
  top: 12px;
  left: 42px;
  font-family: Proxima Nova Regular;
  font-style: normal;
  /* font-weight: normal;*/
  font-size: 17px;
  line-height: 21px;
  /* identical to box height */

  color: #333333;
}

.hearer_lang_select_btn {
  position: absolute;
  top: 18px;
  left: 114px;
}

.hearer_lang_select_btn svg {
  fill: #333;
}

.hearer_lang_select_btn svg:hover {
  fill: #e82862;
}

.hearer_dropdown_lang_select_text {
  left: 42px;
  font-family: Proxima Nova Regular;
  font-style: normal;
  /* font-weight: normal;*/
  font-size: 17px;
  line-height: 21px;
  /* identical to box height */
  padding: 6px 10px;
  color: #333333;
}

.hearer_dropdown_lang_select_text:hover {
  left: 42px;
  font-family: Proxima Nova Regular;
  font-style: normal;
  /* font-weight: normal;*/
  font-size: 17px;
  line-height: 21px;
  /* identical to box height */
  padding: 6px 10px;
  color: #333333;
  background-color: #e3dede;
}
</style>
